<!-- Header -->
<div class="header-icons">
  <app-table-header
    #header
    [showHeader]="false"
    [hasFilter]="false"
    [hasSearchBar]="true"
    [hasAlternateAddItem]="true"
    [rightPadding]="2"
    [hasCollapsedPadding]="false"
    (addItemEvent)="addStop($event)"
    (searchEvent)="search($event)"
    (searchClear)="clearSearch()"
    (exportExcelEvent)="exportExcel()"
  >
    <div class="plan-date">
      <app-form-date-picker
        [(ngModel)]="planDate"
        [disabled]="true"
      ></app-form-date-picker>
    </div>

    <div class="selected-route">
      <img [src]="SRC.LOCATION_DISABLED" alt="route-id" />
      <span> {{ CONSTANTS.ROUTE }} {{ selectedRoute }}</span>
    </div>
  </app-table-header>
</div>

<!-- Body -->
<cdk-virtual-scroll-viewport itemSize="50">
  <div id="operation-route-details">
    <div class="operation-route-details-table-container">
      <table mat-table matSort [dataSource]="dataSource">
        <!-- Stop Number -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef id="id-headers">
            <ion-row class="th-text"> {{ HEADERS.STOP_NUMBER }}</ion-row>
          </th>
          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="id-headers"
                class="right-data-column multi-column"
              >
                <div>
                  {{ routeDetail.index + 1 }}
                </div>
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- Stop Type -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef id="type-headers">
            <ion-row class="th-text"> {{ HEADERS.TYPE }} </ion-row>
          </th>
          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="stopType-headers"
                class="display-stop"
              >
                <div class="stop-types">
                  @switch (routeDetail.type) {
                    <!-- On Demand -->
                    @case ("onDemand") {
                      <img
                        class="stop-type-icons"
                        [src]="SRC.PHONE"
                        alt="stop type"
                      />
                    }
                    <!-- Pickup Stop -->
                    @case ("PS") {
                      <img
                        class="stop-type-icons"
                        [src]="SRC.PICKUP"
                        alt="stop type"
                      />
                    }
                    <!-- Delivery Stop -->
                    @case ("DS") {
                      <img
                        class="stop-type-icons"
                        [src]="SRC.DELIVERY"
                        alt="stop type"
                      />
                    }
                    <!-- Unknown Stop -->
                    @case ("U") {
                      <span>{{ CONSTANTS.UNKNOWN }}</span>
                    }
                  }
                  @if (routeDetail.isStopComplete) {
                    <img
                      class="completed-stops"
                      [src]="SRC.ACTIVE"
                      alt="stop complete"
                    />
                  }
                </div>
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- Density -->
        <ng-container matColumnDef="density">
          <th mat-header-cell *matHeaderCellDef id="density-headers">
            <ion-row class="th-text">
              {{ HEADERS.DENSITY }}
            </ion-row>
          </th>
          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="density-headers"
                class="sub-table-data left-data-column multi-column"
              >
                <div>
                  {{ routeDetail.density }}
                </div>
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- Consignee -->
        <ng-container matColumnDef="cosignee">
          <th mat-header-cell *matHeaderCellDef id="cosignee-headers">
            <ion-row class="th-text"> {{ HEADERS.CONSIGNEE }}</ion-row>
          </th>
          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="cosignee-headers"
                class="left-data-column multi-column"
              >
                <div>
                  {{ routeDetail.cosignee }}
                </div>
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- Street Address -->
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef id="address-headers">
            <ion-row class="th-text"> {{ HEADERS.STREET_ADDRESS }}</ion-row>
          </th>

          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="address-headers"
                class="left-data-column multi-column"
              >
                <div>{{ routeDetail.address }}</div>
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- City -->
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef id="city-headers">
            <ion-row class="th-text"> {{ HEADERS.CITY }}</ion-row>
          </th>
          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="city-headers"
                class="left-data-column multi-column"
              >
                <div>
                  {{ routeDetail.city }}
                </div>
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- Postal -->
        <ng-container matColumnDef="postal">
          <th mat-header-cell *matHeaderCellDef id="postal-headers">
            <ion-row class="th-text"> {{ HEADERS.POSTAL }}</ion-row>
          </th>

          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="postal-headers"
                class="left-data-column multi-column"
              >
                <div>
                  {{ routeDetail.postal }}
                </div>
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- Complete Time-->
        <ng-container matColumnDef="completiontime">
          <th mat-header-cell *matHeaderCellDef id="completionTime-headers">
            <ion-row class="th-text">
              {{ HEADERS.COMPLETE_TIME }}
            </ion-row>
          </th>
          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="completionTime-headers multi-column"
                class="route-border left-data-column multi-column"
              >
                <div>
                  {{ routeDetail.completionTime }}
                </div>
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- Tracking number -->
        <ng-container matColumnDef="trackingnumber">
          <th mat-header-cell *matHeaderCellDef id="trackingNumber-headers">
            <ion-row class="th-text"> {{ HEADERS.TRACKING_NUMBER }}</ion-row>
          </th>

          <td
            mat-cell
            *matCellDef="let routeDetail"
            [ngClass]="{
              'background-color-grey': routeDetail.index % 2 !== 0,
            }"
            headers="trackingNumber-headers"
            class="left-data-column"
          >
            <ion-row>
              <ion-col>
                {{ routeDetail.trackingNumber }}
              </ion-col>
            </ion-row>
          </td>
        </ng-container>

        <!-- Commit Time -->
        <ng-container matColumnDef="committime">
          <th mat-header-cell *matHeaderCellDef id="commitTime-headers">
            <ion-row class="th-text">
              {{ HEADERS.COMMIT }}
            </ion-row>
          </th>
          <td
            mat-cell
            *matCellDef="let routeDetail"
            [ngClass]="{
              'background-color-grey': routeDetail.index % 2 !== 0,
            }"
            headers="commitTime-headers"
            class="right-data-column"
          >
            {{ routeDetail.commitTime }}
          </td>
        </ng-container>

        <!-- ETA -->
        <ng-container matColumnDef="eta">
          <th mat-header-cell *matHeaderCellDef id="eta-headers">
            <ion-row class="th-text">
              {{ HEADERS.ETA }}
            </ion-row>
          </th>
          <td
            mat-cell
            *matCellDef="let routeDetail"
            [ngClass]="{
              'background-color-grey': routeDetail.index % 2 !== 0,
            }"
            headers="eta-headers"
            class="right-data-column"
          >
            {{ routeDetail.eta }}
          </td>
        </ng-container>

        <!-- Scan Code -->
        <ng-container matColumnDef="scancode">
          <th mat-header-cell *matHeaderCellDef id="scanCode-headers">
            <ion-row class="th-text">
              {{ HEADERS.SCAN_CODE }}
            </ion-row>
          </th>
          <td
            mat-cell
            *matCellDef="let routeDetail"
            [ngClass]="{
              'background-color-grey': routeDetail.index % 2 !== 0,
            }"
            headers="scanCode-headers"
            class="left-data-column"
          >
            {{ routeDetail.isStopComplete ? routeDetail.scancodeDesc : "" }}
          </td>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef id="description-headers">
            <ion-row class="th-text">
              {{ HEADERS.DESCRIPTION }}
            </ion-row>
          </th>

          <td
            mat-cell
            *matCellDef="let routeDetail"
            [ngClass]="{
              'background-color-grey': routeDetail.index % 2 !== 0,
            }"
            headers="description-headers"
            class="left-data-column"
          >
            {{ routeDetail.description }}
          </td>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef id="action-headers">
            <ion-row class="th-text center-align"> {{ ACTIONS_TEXT }} </ion-row>
          </th>
          <ng-container mat-cell *matCellDef="let routeDetail; let i = index">
            @if (routeDetail.displayStop) {
              <td
                [attr.rowspan]="getRowSpan(routeDetail)"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="action-headers"
                class="actions-border multi-column"
              >
                @if (!routeDetail.isStopComplete) {
                  <button
                    class="button-for-icons"
                    (click)="editStop(routeDetail)"
                  >
                    <img [src]="IMAGES.EDIT_BLUE" alt="edit" />
                  </button>
                }
              </td>
            }
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row no-results-found" *matNoDataRow>
          <td
            [attr.colspan]="displayedColumns.length"
            class="mat-cell no-border"
          >
            <app-no-results-found></app-no-results-found>
          </td>
        </tr>
      </table>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
